import styled from 'styled-components';

import { FullScreenContainer } from '../../styles/styledComponents';

export default styled(FullScreenContainer)`
  color: white;
  text-align: center;
`;
